import { render, staticRenderFns } from "./version-file-item.vue?vue&type=template&id=6caf1731"
import script from "./version-file-item.vue?vue&type=script&lang=js"
export * from "./version-file-item.vue?vue&type=script&lang=js"
import style0 from "./version-file-item.vue?vue&type=style&index=0&id=6caf1731&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports